import styled from "styled-components";

export const Participate = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 2.5rem 6rem 2.5rem;
  gap: 2rem;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  h2 {
    font-family: "SourceSans3-Bold";
    color: var(--black2, #1d1d1d);
    font-size: 2rem;
    line-height: 2.2rem;
    margin-bottom: 0.5rem;
    text-align: center;
  }
`;

export const ParticipateRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 59.25rem;
  gap: 2rem;

  .Participate {
    height: 0;
    width: 0;
  }
`;

export const ParticipateText = styled.div`
  font-family: "SourceSans3-Regular";
  max-width: 39rem;
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: center;
  text-wrap: balance;

  strong {
    font-family: "SourceSans3-Bold";
    color: var(--primary, #000);
  }

  @media (max-width: 767px) {
    width: 100%;
    margin: 0;
  }
`;
